import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  MIXPANEL_KEY: process.env["MIXPANEL_KEY"] ?? "",
};
